//@ts-nocheck
import {
  Block,
  PartialBlock
} from "@blocknote/core";


let key = 'authorization';
let endPoint = 'http://localhost:3000';
export let frontEndPoint = 'http://localhost:4200';

const requestHeaders = new Headers();
requestHeaders.append('pragma', 'no-cache');
requestHeaders.append('cache-control', 'no-cache');
requestHeaders.append("Content-Type", "application/json");

let initiativeId: any = '';
let subscriptionId: any = '';
let editorValue: any = {};
let currentController = null;

export function setSubscriptionAndInitiativeId(jsonData: any) {
  initiativeId = jsonData?.initiativeId;
  subscriptionId = jsonData?.subscriptionId;
  const teamId: any = jsonData?.teamId;
  editorValue = jsonData;

  if (jsonData.environmentName === 'dev') {
    key = 'devauthorization';
  }
  if (jsonData.environmentName === 'qa') {
    key = 'qaauthorization';
    endPoint = 'https://qa-api.shorterloop.com';
    frontEndPoint = 'https://qa.prodeasy.com';
  }
  if (jsonData.environmentName === 'prod') {
    key = 'prodauthorization';
    endPoint = 'https://api.shorterloop.com';
    frontEndPoint = 'https://app.shorterloop.com';
  }
  const token = getCookie(key);
  if (!token) {
    handleRedirections()
  }

  requestHeaders.append("Authorization", `Bearer ${token}`);
  requestHeaders.append("InitiativeId", initiativeId);
  requestHeaders.append("teamId", teamId);
}

export async function uploadFile(file: File) {
  const form = new FormData();
  form.append(file.name, file);
  form.append('artifactId', editorValue?.id);
  form.append('usedAt', 'wiki');
  const initiativeId = editorValue?.initiativeId;

  const meta = {
    'x-amz-meta-artifactType': 'wiki',
    'x-amz-meta-artifactId': String(editorValue?.id),
    'x-amz-meta-addToAIContext': 'true',
  };

  meta['x-amz-meta-artifactLink'] = `/api/users/initiative/${initiativeId}/wiki/${editorValue?.id}`;

  form.append('meta', JSON.stringify(meta));

  const clonedHeaders = new Headers(requestHeaders);

  clonedHeaders.delete("Content-Type");

  const requestOptions = {
    method: 'POST',
    headers: clonedHeaders,
    body: form
  };

  const ret = await fetch(`${endPoint}/api/assets`, requestOptions);
  const data = await ret.json();
  return `${data.url}/${file.name}`;
}

export async function getInitiativeDetails() {
  if (!initiativeId) {
    return true;
  }
  const requestOptions: any = {
    method: 'get',
    headers: requestHeaders
  };
  const response = await fetch(`${endPoint}/api/initiatives/product-user-mapping/${initiativeId}`, requestOptions);
  const { data } = await response.json();
  return data;
};

export async function getArtifactDetails() {
  if (!initiativeId) {
    return true;
  }
  const requestOptions: any = {
    method: 'get',
    headers: requestHeaders
  };
  const response = await fetch(`${endPoint}/api/initiatives/${initiativeId}/artifacts-tree-structure`, requestOptions);
  const { data } = await response.json();
  return data;
};

export function handleRedirections() {
}

export function getRandomColorFromSet() {
  const colors = [
    '#FFB6C1', // Light Pink
    '#87CEFA', // Light Sky Blue
    '#98FB98', // Pale Green
    '#FFD700', // Gold
    '#FF69B4', // Hot Pink
    '#40E0D0', // Turquoise
    '#FF6347', // Tomato
    '#9370DB', // Medium Purple
    '#F5DEB3'  // Wheat
  ];

  const randomIndex = Math.floor(Math.random() * colors.length);
  return colors[randomIndex];
}
export function getCookie(cookieName: any) {
  const cookie: any = {};
  document.cookie.split(';').forEach(function (el) {
    const [key, value] = el.split('=');
    cookie[key.trim()] = value;
  });

  return cookie[cookieName];
}
function getPageName(jsonArray: any) {
  for (const item of jsonArray) {
    // Check if 'content' exists and is an array
    if (item.content && Array.isArray(item.content)) {
      for (const content of item.content) {
        // Check if 'text' exists and is not empty after trimming
        if (content.text && content.text.trim()) {
          const trimmedText = content.text.trim(); // Trim the text
          return trimmedText.length > 40 ? trimmedText.slice(0, 40) : trimmedText; // Return trimmed text if it exceeds 40 characters
        }
      }
    }
  }
  return null; // Return null if no non-empty text is found
}

export function debounce(func, delay=500) {
  let timeout = null
  return (...args) => {
    if (timeout) clearTimeout(timeout)

    timeout = setTimeout(() => {
      func(...args)
      timeout = null
    }, delay)
  }
}


/**
 * Saves the provided jsonBlocks and value to storage.
 *
 * @param {Block[]} jsonBlocks - The array of blocks to be saved.
 * @param {any} value - The value object containing additional information.
 * @returns {Promise<any>} A promise that resolves to the saved data.
 */
export const saveToStorage = debounce(async (editor, jsonBlocks, value) => {
  if (currentController) {
    currentController.abort();
  }
  const title = getPageName(jsonBlocks);
  const html = await editor.blocksToHTMLLossy(jsonBlocks);

  const payload: any = {
    body: jsonBlocks,
    title,
    html,
    isAssociatedWithWorkItem: value?.isAssociatedWithWorkItem
  };

  const requestOptions: any = {
    method: 'PUT',
    headers: requestHeaders,
    body: JSON.stringify(payload),
  };

  const savedPageId = value?.id;
  if (!savedPageId) {
    return false;
  }
  currentController = new AbortController();
  requestOptions.method = 'PUT';
  const pageId = 'page/' + savedPageId;
  requestOptions.signal = currentController.signal;

  try {
    const response = await fetch(`${endPoint}/api/wiki/${pageId}`, requestOptions);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const { data } = await response.json();
    if (data) {
      const alias = data?.alias;
      value.alias = alias;
      value.title = title;

      window.parent.postMessage({
        type: 'PAGE_ALIAS_UPDATED',
        ...value
      }, '*');
    }
    return data;
  }
  catch (error) {
    if (error.name === 'AbortError') {
      console.log('Previous PUT request was cancelled.');
    } else {
      console.error('PUT request error:', error);
    }
  } finally {
    currentController = null;
  }
});
/**
 * Fetches wiki data based on the provided jsonData and inserts it into the editor.
 *
 * @param {any} jsonData - The data object containing the wiki page ID.
 * @param {any} editor - The editor instance where the fetched data will be inserted.
 */
export function fetchWikiData(jsonData: any, editor: any) {
  editor.blockCache = new WeakMap();
  editor.document.length = 0;
  const requestOptions = {
    method: 'GET', // Ensure method is GET
    headers: requestHeaders, // Your existing headers
  };

  let url = `${endPoint}/api/wiki/${jsonData?.id}?view=body`;
  if (jsonData?.isAssociatedWithWorkItem) {
    url += `&isAssociatedWithWorkItem=true`;
  }

  fetch(url, requestOptions)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(async result => {

      let body = result?.data?.body || [];
      body = body as PartialBlock[];
      editor.insertBlocks(body, editor.document[0]); // Insert the result into the editor
    })
    .catch(error => {
      console.error('There was a problem with the fetch operation:', error);
    });
}
